'use client'
import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useAudioRef } from '../context/AudioContext'

export default function SoundButton() {
  const audioStateRef = useAudioRef()
  const [playing, setPlaying] = useState(false)
  const [fading, setFading] = useState(false)
  const [muted, setMuted] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      const s = audioStateRef.current
      setPlaying(s.playing)
      setFading(s.fading)
    }, 100)
    return () => clearInterval(interval)
  }, [audioStateRef])

  const toggle = () => {
    const audio = audioStateRef.current.audio
    if (audio) {
      audio.muted = !audio.muted
      setMuted(audio.muted)
    }
  }

  return (
    <AnimatePresence>
      {playing && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8, x: -20 }}
          animate={{ opacity: fading ? 0 : 1, scale: 1, x: 0 }}
          exit={{ opacity: 0, scale: 0.8, x: -20 }}
          transition={{ opacity: { duration: fading ? 4 : 0.3 }, scale: { duration: 0.3 }, x: { duration: 0.3 } }}
          onClick={toggle}
          className="fixed bottom-6 left-6 z-50 w-10 h-10 flex items-center justify-center rounded-full glass cursor-pointer hover:bg-white/10 transition-colors"
          title={muted ? 'Unmute' : 'Mute'}
        >
          {muted ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white/70">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <line x1="23" y1="9" x2="17" y2="15" />
              <line x1="17" y1="9" x2="23" y2="15" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white/70">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
              <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
            </svg>
          )}
        </motion.button>
      )}
    </AnimatePresence>
  )
}
